import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { setUserSession } from './service/AuthService';

import './css/Login-Register.css';
import logoBold from './assets/logoBold.png';
import { MateriaBasicTextField, MaterialPassword } from './MaterialComponents';


//TODO: move this to an environment variable
const resetRequestUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/resetpassrequest';
const loadingSpinner = document.querySelector('.donut');


const PasswordReset = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    //Learning Form Data (move it here)
    function handleUsernameState(newValue) {
        setUsername(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }

    const [message, setMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);


    const navigate = useNavigate()

    const loginHandler = () => {
        console.log('lets go back to login woooo')
        navigate('/login');
    }

    const submitHandler = (event) => {
        event.preventDefault();
        setMessage(null)
        setMessage("If an account with that email exists, we've sent a password reset link. Please check your inbox.")
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
        }



        axios.post(resetRequestUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            console.log('login data response')
            console.log(response.data)
            // console.log(response.data.user.onboardingComplete)
            // //TODO: fix bug -- update always shows up
            // if(!response.data.user.onboardingComplete){
            //     navigate('/onboarding-demo');
            // }
            // else{
            //     document.querySelector('.header').style.display = 'block'
            //     navigate('/daily-content'); 
            // }
            
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    useEffect(() => {
        document.querySelector('.header').style.display = 'none'
        if (loadingSpinner) {
            console.log('deleting donute')
            loadingSpinner.style.display = 'none'; // Example: Change the text color
        }
    }, []);

    return (
        <div style={{ marginLeft: '2rem', marginRight: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '2rem'}}> 
            <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1rem', paddingTop: '5rem'}}>
                <img style={{ width: '95%', maxWidth: '415px', marginBottom: '1rem' }} src={logoBold} alt="Example" />
            </div>
            <form onSubmit = { submitHandler }>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <h4 className="form-title" style={{ textAlign: 'center' }}>Forgot Password?</h4>
                    <p className="form-title" style={{ textAlign: 'center', maxWidth: '330px' }}>Enter your email address and we'll send you a password reset link.</p>

                    <div className="relapseQuestion">email:</div>
                    <MateriaBasicTextField handleChange={handleUsernameState}/>
                    {message && <p className="message" style={{ paddingBottom: "1rem" }}> { message } </p>}

                    {/* <div className="relapseQuestion">password:</div> */}
                    {/* <MaterialPassword handleChange={handlePasswordState} /> */}
                    {/* <MateriaBasicTextField type={isShown ? "text" : "password"} handleChange={handlePasswordState} /> */}
                    {/* username: <input type="text" value={username} onChange={event => setUsername(event.target.value)} /> <br /> */}
                    {/* password: <input type={isShown ? "text" : "password"} className="input" value={password} onChange={event => setPassword(event.target.value)} /> <br /> */}
                    {/* <input style={{ marginTop: '2rem' }} className="submit-bttn" type="submit" value="Login" /> */}
                    <button type="submit" className="homeBttn" style={{ marginTop: '3rem', width: '310px' }}>Reset Password</button>
                    <button className="homeBttn" style={{ marginTop: '1.5rem', width: '310px' }} onClick={loginHandler}>Back to Login</button>
                </div>
            </form>
            {/* <button className="homeBttn" style={{ marginTop: '1.5rem', width: '310px', marginBottom: '1rem' }} onClick={registerHandler}>Register</button> */}

            {/* <div className="button-container-login-register">
                <button className="login button-login-register">Login</button>
                <button className="register button-login-register" onClick={registerHandler}>Register</button>
            </div> */}
        </div>
    )
}


export default PasswordReset;